import React from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'

import getApplicationConfig from '../../../common/config'
import { AuthContext } from '../../../common/AuthContext'
import { applyFeatureRoleOverrides } from '../../utils/featureRoleOverrides'

function withConfig (Component, hrefValue = window.location.href) {
  function Wrapper ({innerRef, ...props}) {
    // useContext, not AuthContext.Consumer - keeps shallow(...).dive() working elsewhere
    const { user } = React.useContext(AuthContext)
    const baseConfig = getApplicationConfig(hrefValue)
    const features = React.useMemo(
      () => applyFeatureRoleOverrides(baseConfig.features, baseConfig.env, user),
      [baseConfig.features, baseConfig.env, user]
    )
    // reuse the same (memoized-singleton) config object whenever nothing
    // was overridden, so referential equality downstream is unaffected
    const config = features === baseConfig.features ? baseConfig : { ...baseConfig, features }

    return (
      <Component
        {...props}
        ref={innerRef}
        config={config}
      />
    )
  }
  Wrapper.displayName = `withConfig(${Component.displayName || Component.name})`
  Wrapper.WrappedComponent = Component
  return hoistNonReactStatics(Wrapper, Component)
}

export default withConfig
